import integrationsGetters from "./getters.js";
import integrationsMutations from "./mutations.js";
import integrationsActions from "./actions.js";

export default {
  namespaced: true,
  state() {
    return {
      integrationTimestamp: null,
      carriers: [],
      features: [],
      integrations: [],
    };
  },
  getters: integrationsGetters,
  mutations: integrationsMutations,
  actions: integrationsActions,
};
